import PropTypes from "prop-types";
import { forwardRef } from "react";
import { Link as RouterLink } from "react-router-dom";
// @mui
import { Box, Link } from "@mui/material";

// ----------------------------------------------------------------------

const Logo = forwardRef(({ disabledLink = false, sx, ...other }, ref) => {
  const logo = (
    <Box
      ref={ref}
      component="div"
      sx={{
        width: 44,
        height: 44,
        display: "inline-flex",
        flexShrink: 0,
        ...sx,
      }}
      {...other}
    >
      <svg viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%', height: '100%' }}>
        <defs>
          {/* SFM amber gradient — reads on the dark-slate sidebar chrome */}
          <linearGradient id="sfmGrad" x1="0" y1="0" x2="44" y2="44" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#FAB360" />
            <stop offset="100%" stopColor="#C26F0E" />
          </linearGradient>
          <linearGradient id="sfmSheen" x1="0" y1="0" x2="0" y2="22" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="rgba(255,255,255,0.25)" />
            <stop offset="100%" stopColor="rgba(255,255,255,0.00)" />
          </linearGradient>
        </defs>
        {/* iOS app-icon shape */}
        <rect width="44" height="44" rx="11" fill="url(#sfmGrad)" />
        {/* Glass sheen overlay */}
        <rect width="44" height="22" rx="11" fill="url(#sfmSheen)" />
        {/* SFM wordmark */}
        <text
          x="22"
          y="27"
          textAnchor="middle"
          fontSize="13"
          fontWeight="700"
          fill="white"
          fontFamily="-apple-system, BlinkMacSystemFont, 'SF Pro Display', sans-serif"
          letterSpacing="-0.3"
        >
          SFM
        </text>
      </svg>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return (
    <Link to="/" component={RouterLink} sx={{ display: "contents" }}>
      {logo}
    </Link>
  );
});

Logo.propTypes = {
  sx: PropTypes.object,
  disabledLink: PropTypes.bool,
};

export default Logo;
